import { initialUOMState, IUOMState } from '../state/uom.state';
import { UOMAction, EUOMActions } from '../actions/uom.action';


export function uomReducers(state = initialUOMState, action: UOMAction): IUOMState {
    switch (action.type) {

        case EUOMActions.GetUOMDetails: {
            return {
                ...state,
                getUOMDetails: action.payload,
                getUOMErrorMessage: null
            };
        }
        case EUOMActions.SetUOMSuccess: {
            const success = {
                data : action.payload,
                from : action.from
            }
            return {
                ...state,
                getUOMSuccessMessage: success,
                getUOMErrorMessage: null
            };
        }
        case EUOMActions.SetUOMError: {
            const error = {
                data : action.payload,
                from : action.from
            }
            return {
                ...state,
                getUOMErrorMessage: error,
                getUOMDetails: null
            };
        }
        case EUOMActions.GetEditUOMSuccess: {
            return {
                ...state,
                getEditUOMSuccess: action.payload,
                getEditUOMError: null
            };
        }
        case EUOMActions.GetEditUOMError: {
            return {
                ...state,
                getEditUOMError: action.payload,
                getEditUOMSuccess: null
            };
        }
        default: {   
            return state;
          }
    }

}